import React from "react";
import ReactDOM from "react-dom";
import "./DailyRewardModal.css";

export default function DailyRewardModal({ isOpen, onClose, item }) {
  if (!isOpen) return null;

  const itemName = item?.name || "Null Item";
  const itemRarity = item?.rarity ? item.rarity.toLowerCase() : "common";
  const itemId = item?.id || "fallback";
  const itemDescription = item?.description || "No data available.";

  const rarityNames = {
    legendary: "UNIQUE",
    epic: "PROTOTYPE",
    rare: "EXPERIMENTAL",
    uncommon: "REFINED",
    common: "STANDARD"
  };

  const getRarityColor = (rarity) => {
    switch (rarity?.toLowerCase()) {
      case 'legendary': return '#ffb100';
      case 'epic': return '#a335ee';
      case 'rare': return '#0070dd';
      case 'uncommon': return '#1eff00';
      default: return '#888888';
    }
  };

  const rarityColor = getRarityColor(itemRarity);

  const modalContent = (
    <div className="confirm-modal-overlay">

      <div 
        className="confirm-modal-container daily-reward-container" 
        style={{ 
          "--tier-color": rarityColor,
          borderColor: rarityColor,
          boxShadow: `0 0 20px ${rarityColor}33`,
          background: "#050505"
        }}
      >
        
        <div className="daily-reward-title" style={{ color: "#fff", letterSpacing: '1px' }}>
          ASSET RECEIVED
        </div>

        <span 
          className="daily-reward-badge" 
          style={{ 
            color: '#000', 
            background: rarityColor, 
            fontWeight: 'bold',
            fontSize: '0.55rem',
            padding: '2px 6px',
            textTransform: 'uppercase'
          }}
        >
          {rarityNames[itemRarity] || "ASSET DROP"}
        </span>

        <div className="daily-reward-name-display" style={{ color: '#fff', fontWeight: 'bold', margin: '12px 0 4px 0' }}>
          {itemName.toUpperCase()}
        </div>

        <div 
          className="daily-reward-shimmer-box"
          style={{
            border: `1px solid ${rarityColor}22`,
            background: `linear-gradient(180deg, ${rarityColor}05 0%, rgba(0,0,0,0.3) 100%)`,
            padding: '15px',
            borderRadius: '2px',
            marginTop: '10px'
          }}
        >
          <div style={{ width: '100%', height: '80px', display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '12px' }}>
            <img 
              src={`/items/${itemId}.png`} 
              alt={itemName} 
              className="daily-reward-sprite"
              style={{ 
                maxWidth: '100%', 
                maxHeight: '100%', 
                objectFit: 'contain', 
                filter: `drop-shadow(0 0 6px ${rarityColor}aa)` 
              }}
              onError={(e) => { 
                e.currentTarget.onerror = null;
                e.currentTarget.style.display = 'none';
                e.currentTarget.parentElement.innerHTML = `<span style="font-size: 2rem; color: ${rarityColor};">${itemRarity === 'legendary' ? '✦' : '⬡'}</span>`;
              }}
            />
          </div>

          <div 
            className="daily-reward-feature-text" 
            style={{ 
              color: '#fff', 
              fontSize: '0.6rem', 
              fontStyle: 'italic',
              lineHeight: '1.4',
              textAlign: 'center'
            }}
          >
            {itemDescription}
          </div>
        </div>

        <div className="daily-reward-actions" style={{ marginTop: '16px' }}>
          <button 
            className="daily-reward-btn" 
            onClick={onClose}
            style={{
              background: 'transparent',
              border: `1px solid ${rarityColor}`,
              color: rarityColor,
              padding: '8px 20px',
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: '0.65rem',
              fontWeight: 'bold',
              cursor: 'pointer',
              transition: 'all 0.15s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = rarityColor;
              e.currentTarget.style.color = '#000';
              e.currentTarget.style.boxShadow = `0 0 10px ${rarityColor}66`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.color = rarityColor;
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            CLAIM
          </button>
        </div>
        
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
}